// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedIr800Flow800_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill="#9AB3DB" d="M0 0H24V24H0z"/>
  <path fill="#EDF2F7" d="M0 0H24V24H0z"/>
  <path fill="url(#a)" d="M1 12H23V23H1z"/>
  <path fill="#07090D" d="M1 1H12V12H1z"/>
  <path class="svg-fg" d="M12 1H23V12H12z"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M20 12L15 8V11H4V13H15V16L20 12Z" class="svg-fg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M14 5.91992L21.6008 12.0005L14 18.0812V14.0005H3V10.0005H14V5.91992ZM15 11.0005H4V13.0005H15V16.0005L20 12.0005L15 8.00055V11.0005Z" fill="#353D45"/>
  <defs>
    <linearGradient id="a" x1="1" y1="21.854" x2="23" y2="21.854" gradientUnits="userSpaceOnUse">
      <stop stop-color="#ED5353"/>
      <stop offset=".163" stop-color="#EF8354"/>
      <stop offset=".329" stop-color="#FDCA40"/>
      <stop offset=".538" stop-color="#A8E431"/>
      <stop offset=".678" stop-color="#38CD56"/>
      <stop offset=".809" stop-color="#00A6FB"/>
      <stop offset=".986" stop-color="#0050F2"/>
    </linearGradient>
  </defs>
</svg>
`;
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill="#EDF2F7" d="M0 0H32V32H0z"/>
  <path fill="url(#a)" d="M1 16H31V31H1z"/>
  <path class="svg-fg" d="M16 1H31V16H16z"/>
  <path fill="#07090D" d="M1 1H16V16H1z"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M26 16.0012L20 11.2012V15.001H5V17.001H20V20.8012L26 16.0012Z" class="svg-fg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M18 7.03906L29.2016 16.0003L18 24.9616V19.0001H3V13.0001H18V7.03906ZM20 15.0001H5V17.0001H20V20.8003L26 16.0003L20 11.2003V15.0001Z" fill="#353D45"/>
  <defs>
    <linearGradient id="a" x1="1" y1="29.438" x2="31" y2="29.438" gradientUnits="userSpaceOnUse">
      <stop stop-color="#ED5353"/>
      <stop offset=".163" stop-color="#EF8354"/>
      <stop offset=".329" stop-color="#FDCA40"/>
      <stop offset=".538" stop-color="#A8E431"/>
      <stop offset=".678" stop-color="#38CD56"/>
      <stop offset=".809" stop-color="#00A6FB"/>
      <stop offset=".986" stop-color="#0050F2"/>
    </linearGradient>
  </defs>
</svg>
`;
const _s48IconSvg = html `<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill="#EDF2F7" d="M0 0H48V48H0z"/>
  <path fill="url(#a)" d="M1 24H47V47H1z"/>
  <path class="svg-fg" d="M24 1H47V24H24z"/>
  <path fill="#07090D" d="M1 1H24V24H1z"/>
  <path d="M40 24L30 16V22H8V26H30V32L40 24Z" class="svg-fg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M28 11.8379L43.2016 23.9991L28 36.1604V27.9991H6V19.9991H28V11.8379ZM30 21.9991H8V25.9991H30V31.9991L40 23.9991L30 15.9991V21.9991Z" fill="#353D45"/>
  <defs>
    <linearGradient id="a" x1="1" y1="44.604" x2="47" y2="44.604" gradientUnits="userSpaceOnUse">
      <stop stop-color="#ED5353"/>
      <stop offset=".163" stop-color="#EF8354"/>
      <stop offset=".329" stop-color="#FDCA40"/>
      <stop offset=".538" stop-color="#A8E431"/>
      <stop offset=".678" stop-color="#38CD56"/>
      <stop offset=".809" stop-color="#00A6FB"/>
      <stop offset=".986" stop-color="#0050F2"/>
    </linearGradient>
  </defs>
</svg>
`;
/**
 * IconMedIr800Flow800 is a generated icon component.
 */
let IconMedIr800Flow800 = IconMedIr800Flow800_1 = class IconMedIr800Flow800 extends IconBaseElement {
    render() {
        return html `${IconMedIr800Flow800_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedIr800Flow800.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s48IconSvg],
    ['s48', _s48IconSvg],
    ['s64', _s48IconSvg],
    ['s72', _s48IconSvg],
    ['s80', _s48IconSvg],
]);
IconMedIr800Flow800 = IconMedIr800Flow800_1 = __decorate([
    customElement('zui-icon-med-ir-800-flow-800')
], IconMedIr800Flow800);
export { IconMedIr800Flow800 };
